<template>
  <div class="space-between-y">

    <el-dialog
        title="订单详情"
        :visible.sync="detail.dialog"
        width="600px"
    >
      <miu-vip-order-detail :id="detail.id" v-if="detail.dialog"></miu-vip-order-detail>
    </el-dialog>

    <div class="container-left space-between-x">
      <input-item width="220" label="关键搜索">
        <el-input clearable v-model="form.keyword" placeholder="搜索下单人/手机号/订单编号"></el-input>
      </input-item>
      <input-item width="150" label="VIP类型">
        <el-select clearable v-model="form.miuAuthType" placeholder="请选择">
          <el-option value="teacher" label="教师"></el-option>
          <el-option value="parent" label="家长"></el-option>
        </el-select>
      </input-item>
      <input-item width="150" label="支付状态">
        <el-select clearable v-model="form.payStatus" placeholder="请选择">
          <el-option value="SUCCESS" label="支付成功"></el-option>
          <el-option value="REFUND" label="转入退款"></el-option>
          <el-option value="NOTPAY" label="未支付"></el-option>
          <el-option value="CLOSED" label="已关闭"></el-option>
          <el-option value="REVOKED" label="已撤销"></el-option>
          <el-option value="USERPAYING" label="用户支付中"></el-option>
          <el-option value="PAYERROR" label="支付失败"></el-option>
          <el-option value="ACCEPT" label="已接收"></el-option>
        </el-select>
      </input-item>
      <input-item>
        <el-button @click="getData" type="primary">查询VIP订单</el-button>
      </input-item>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column label="#" type="index"></el-table-column>
      <el-table-column show-overflow-tooltip label="提交时间" prop="createTime" width="165"></el-table-column>
      <el-table-column show-overflow-tooltip label="订单编号" prop="number" width="180"></el-table-column>
      <el-table-column show-overflow-tooltip label="订单价格" prop="price"></el-table-column>
      <el-table-column show-overflow-tooltip label="VIP方案" prop="planName"></el-table-column>
      <el-table-column show-overflow-tooltip width="120" label="支付状态" prop="payStatus">
        <template slot-scope="scope">
          <div v-if="scope.row.payStatus === 'CLOSED'" class="info-text">{{ scope.row.payStatus }}</div>
          <div v-else>{{ scope.row.payStatus }}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="支付时间" width="165" prop="payTime">
        <template slot-scope="scope">
          <div v-if="scope.row.payTime">{{ scope.row.payTime }}</div>
          <div v-else class="info-text">-</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="下单用户" width="160">
        <template slot-scope="scope">
          <div class="user">
            <cloud-img :url="scope.row.miuUserAvatar" :img-height="30" :img-width="30" :border-radius="4"></cloud-img>
            <div class="name">{{ scope.row.miuUserName }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="70">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" size="mini" @click="showDetail(scope.row)">详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>

  </div>
</template>

<script>
import Pagination from "@/components/base/layout/Pagination.vue";
import {vip} from "@/api/miu/vip";
import InputItem from "@/components/base/layout/InputItem.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import MiuVipOrderDetail from "@/components/miu/vip/MiuVipOrderDetail.vue";

export default {
  name: 'MiuVipOrder',
  components: {MiuVipOrderDetail, CloudImg, InputItem, Pagination},
  data() {
    return {
      page: {
        size: 10,
        current: 1,
        total: 0,
      },


      option: {},

      list: [],

      form: {
        miuAuthType: null,
        keyword: null,
        payStatus: null,
      },

      detail: {
        dialog: false,
        id: null,
      },

    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      vip.order.list(this.form.miuAuthType, this.form.keyword, this.form.payStatus, this.page.current, this.page.size).then(res => {
        let page = res.data;
        this.list = page.list;
        this.page.total = page.total;
      })
    },

    showDetail(order) {
      this.detail.dialog = true;
      this.detail.id = order.id;
    },
  },

}
</script>

<style scoped>

.user {
  display: flex;
  gap: 6px;
}

</style>
